(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-mobile-menu')) {
    class ScMobileMenu extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-sc-open]');
        this.closeButton = this.querySelector('[data-sc-close]');
        this.searchInput = this.querySelector('input[type="search"]');
        this.searchForm = this.querySelector('form[role="search"]');
        this.suggestions = this.querySelector('[data-sc-suggestions]');
        this.results = this.querySelector('[data-sc-results]');
        this.searchNote = this.querySelector('[data-sc-search-note]');
        this.searchStatus = this.querySelector('[data-sc-search-status]');
        this.searchAll = this.querySelector('[data-sc-search-all]');
        this.browse = this.querySelector('[data-sc-browse]');
        this.searchCache = new Map();
        this.activeResult = -1;
        const options = { signal: this.abortController.signal };
        this.trigger.addEventListener('click', () => this.open(), options);
        this.closeButton.addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => this.restore(), options);
        this.dialog.addEventListener('cancel', (event) => {
          if (!this.suggestions.hidden) {
            event.preventDefault();
            this.dismissSuggestions();
          }
        }, options);
        this.searchInput.addEventListener('input', (event) => {
          if (!event.isComposing) this.scheduleSearch();
        }, options);
        this.searchInput.addEventListener('compositionend', () => this.scheduleSearch(), options);
        this.searchInput.addEventListener('focus', () => {
          if (this.suggestions.hidden) this.scheduleSearch();
        }, options);
        this.searchInput.addEventListener('keydown', (event) => this.onSearchKeydown(event), options);
        this.searchForm.addEventListener('submit', (event) => {
          if (!this.searchInput.value.trim()) event.preventDefault();
        }, options);
        this.results.addEventListener('focusin', (event) => {
          const items = [...this.results.querySelectorAll('[data-sc-product]')];
          this.selectResult(items.indexOf(event.target));
        }, options);
        this.dialog.addEventListener('click', (event) => {
          const link = event.target.closest('a[href]');
          if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) this.dialog.close();
        }, options);
        this.dialog.querySelectorAll('.sc-mobile-menu__group').forEach((group) => {
          group.addEventListener('toggle', () => {
            if (!group.open) return;
            this.dialog.querySelectorAll('.sc-mobile-menu__group').forEach((other) => {
              if (other !== group) other.open = false;
            });
          }, options);
        });
        window.addEventListener('resize', () => {
          if (window.innerWidth >= 750 && this.dialog.open) this.dialog.close();
        }, options);
        window.addEventListener('pagehide', () => {
          if (this.dialog.open) this.dialog.close();
          this.restore();
        }, options);
      }
      open() {
        if (this.dialog.open) return;
        this.scrollY = window.scrollY;
        this.savedBody = {};
        ['position', 'top', 'width', 'overflow'].forEach((property) => {
          this.savedBody[property] = document.body.style[property];
        });
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.dialog.querySelector('.sc-mobile-menu__scroll').scrollTop = 0;
        this.closeButton.focus({ preventScroll: true });
        if (this.searchInput.value.trim().length >= 2) this.scheduleSearch();
      }
      scheduleSearch() {
        this.dismissSuggestions();
        const query = this.searchInput.value.trim();
        if (query.length < 2 || !this.dialog.open) return;
        const searchUrl = new URL(this.searchForm.action, window.location.origin);
        searchUrl.searchParams.set('q', query);
        searchUrl.searchParams.set('type', 'product');
        searchUrl.searchParams.set('options[prefix]', 'last');
        this.searchAll.href = searchUrl.toString();
        this.suggestions.hidden = false;
        this.browse.hidden = true;
        this.showSearchNote(this.dataset.searchLoading);
        this.results.setAttribute('aria-busy', 'true');
        this.searchTimer = window.setTimeout(() => this.fetchSuggestions(query), 250);
      }
      async fetchSuggestions(query) {
        if (this.searchCache.has(query)) {
          this.renderSuggestions(this.searchCache.get(query));
          return;
        }
        const controller = new AbortController();
        this.searchRequest = controller;
        try {
          const url = new URL(this.dataset.predictiveUrl, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          url.searchParams.set('section_id', 'sc-mobile-predictive-search');
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Search unavailable');
          const html = await response.text();
          if (controller.signal.aborted || this.searchRequest !== controller || !this.dialog.open) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const content = parsed.querySelector('[data-sc-predictive-content]');
          if (!content?.querySelector('template[data-sc-product-results]')) throw new Error('Missing search results');
          this.searchCache.set(query, content);
          if (this.searchCache.size > 20) this.searchCache.delete(this.searchCache.keys().next().value);
          this.renderSuggestions(content);
        } catch (error) {
          if (controller.signal.aborted || this.searchRequest !== controller) return;
          this.results.setAttribute('aria-busy', 'false');
          this.showSearchNote(this.dataset.searchError);
        }
      }
      renderSuggestions(content) {
        const template = content.querySelector('template[data-sc-product-results]');
        this.results.replaceChildren(template.content.cloneNode(true));
        const items = [...this.results.querySelectorAll('[data-sc-product]')];
        items.forEach((item, index) => { item.id = `${this.searchInput.id}-product-${index}`; });
        this.results.setAttribute('aria-busy', 'false');
        this.searchInput.setAttribute('aria-expanded', String(items.length > 0));
        const status = content.querySelector('[data-sc-result-status]').textContent.trim();
        this.searchNote.hidden = items.length > 0;
        this.searchNote.textContent = items.length ? '' : status;
        this.searchStatus.textContent = status;
      }
      showSearchNote(message) {
        this.searchNote.hidden = false;
        this.searchNote.textContent = message;
        this.searchStatus.textContent = message;
      }
      onSearchKeydown(event) {
        if (event.isComposing) return;
        if (event.key === 'Escape' && !this.suggestions.hidden) {
          event.preventDefault();
          event.stopPropagation();
          this.dismissSuggestions();
          return;
        }
        const items = [...this.results.querySelectorAll('[data-sc-product]')];
        if (this.suggestions.hidden || !items.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const next = this.activeResult < 0 ? (event.key === 'ArrowDown' ? 0 : items.length - 1) : (this.activeResult + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
          this.selectResult(next);
          items[next].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && this.activeResult >= 0) {
          event.preventDefault();
          items[this.activeResult].click();
        }
      }
      selectResult(index) {
        this.activeResult = index;
        const items = [...this.results.querySelectorAll('[data-sc-product]')];
        items.forEach((item, itemIndex) => item.setAttribute('aria-selected', String(itemIndex === index)));
        if (items[index]) this.searchInput.setAttribute('aria-activedescendant', items[index].id);
        else this.searchInput.removeAttribute('aria-activedescendant');
      }
      dismissSuggestions() {
        window.clearTimeout(this.searchTimer);
        this.searchRequest?.abort();
        this.searchRequest = null;
        this.activeResult = -1;
        this.results.replaceChildren();
        this.results.setAttribute('aria-busy', 'false');
        this.searchInput.setAttribute('aria-expanded', 'false');
        this.searchInput.removeAttribute('aria-activedescendant');
        this.suggestions.hidden = true;
        this.browse.hidden = false;
        this.searchStatus.textContent = '';
      }
      restore() {
        this.dismissSuggestions();
        if (!this.savedBody) return;
        Object.entries(this.savedBody).forEach(([property, value]) => {
          document.body.style[property] = value;
        });
        this.savedBody = null;
        window.scrollTo({ top: this.scrollY, behavior: 'instant' });
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.isConnected && window.innerWidth < 750) this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.restore();
        this.abortController?.abort();
      }
    }
    customElements.define('sc-mobile-menu', ScMobileMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
